import { apiClient } from '../../../lib/apiClient';

export interface RecipeIngredient {
  item: { id: string; name: string; sku: string; unit: string; minStock?: number; cost?: number };
  qty: number;
  unit: string;
  notes?: string;
}

export interface ProductRecipe {
  _id: string;
  productId: string;
  name?: string;
  ingredients: RecipeIngredient[];
  active: boolean;
  createdAt: string;
}

export interface UpsertRecipePayload {
  productId: string;
  name?: string;
  ingredients: {
    itemId: string;
    qty: number;
    unit: string;
    notes?: string;
  }[];
}

const mapBackendToFrontend = (recipe: any): ProductRecipe => {
  return {
    _id: String(recipe.id),
    productId: String(recipe.product_id),
    name: recipe.name ?? undefined,
    active: !!recipe.active,
    createdAt: recipe.created_at,
    ingredients: (recipe.ingredients || []).map((ing: any) => {
      const item = ing.inventory_item || ing.inventoryItem || {};
      return {
        item: {
          id: String(item.id || ing.inventory_item_id),
          name: item.name || '',
          sku: item.sku || '',
          unit: item.unit || ing.unit || '',
          minStock: item.min_stock !== undefined ? Number(item.min_stock) : undefined,
          cost: item.cost !== undefined ? Number(item.cost) : undefined,
        },
        qty: Number(ing.qty),
        unit: ing.unit || '',
        notes: ing.notes ?? undefined,
      };
    }),
  };
};

export const listRecipes = async (): Promise<ProductRecipe[]> => {
  const { data } = await apiClient.get<any[]>('/inventory/recipes');
  return (data || []).map(mapBackendToFrontend);
};

export const getRecipe = async (productId: string): Promise<ProductRecipe> => {
  const { data } = await apiClient.get<any>(`/inventory/recipes/${productId}`);
  return mapBackendToFrontend(data);
};

export const upsertRecipe = async (payload: UpsertRecipePayload): Promise<ProductRecipe> => {
  const backendPayload = {
    product_id: Number(payload.productId),
    name: payload.name,
    ingredients: payload.ingredients.map((ing) => ({
      inventory_item_id: Number(ing.itemId),
      qty: Number(ing.qty),
      unit: ing.unit,
      notes: ing.notes,
    })),
  };
  const { data } = await apiClient.post<any>('/inventory/recipes', backendPayload);
  return mapBackendToFrontend(data);
};

